<template>
  <Modal v-model="isModalOpen" :header="false" :footer="false" class="outcome-modal">
    <template #default>
      <div class="modal-content-container">
        <div class="modal-header">
          <h1>Complete Pathway?</h1>
        </div>
        <p class="paragraph-one">
          Marking this Pathway as complete will close the Pathway for all team members.
        </p>
        <p class="paragraph-two">
          Team members will see the Congratulations page when they next visit your Team Dashboard.
          The Pathway will also be closed for any team members who have not completed all of the
          Pathway Steps, so best to check before you hit 'Complete'!
        </p>
        <div class="modal-footer">
          <button class="btn btn-default" @click="openModal" type="button">Cancel</button>
          <button
            class="btn btn-primary"
            @click="completePathwayForTeam"
            data-test="admin-complete-pathway-btn"
            type="button"
          >
            Complete
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { Modal } from "uiv";
import axios from "axios";
import { debug as d } from "debug";
import { useRoute } from "vue-router";

const debug = d("cs.CompletePageModal");

const props = defineProps<{
  teamId: string;
  pathwayId: string;
}>();

const isModalOpen = ref(false);
const route = useRoute();
const asaccredited = computed(() => route.query.asaccredited as string);

function openModal(): void {
  isModalOpen.value = !isModalOpen.value;
}

async function completePathwayForTeam(): Promise<void> {
  try {
    await axios.post("/api/TeamMemberCompletedPathway", {
      teamId: props.teamId,
      cmsPathwayId: props.pathwayId,
    });
  } catch (e) {
    debug(e);
  } finally {
    window.location.href = asaccredited.value === 'true'
              ? `/myorganisation/group/details/${props.teamId}`
      : `/home?view=TeamDashboard&team=${props.teamId}`;
  }
}

defineExpose({
  openModal,
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";
@modal-left-margin: 20px + @side-nav-collapsed-width;

.outcome-modal {
  margin: 2rem 20px 2rem @modal-left-margin;
  @media (max-width: @screen-md) {
    margin: 2rem 20px 2rem @modal-left-margin;
  }
  @media (max-width: @screen-sm) {
    margin-top: 10rem;
  }
  @media (max-width: @screen-xs) {
    margin: 15rem 2rem;
  }
  @media (max-width: 380px) {
    margin: 2rem 2rem;
  }
}
.modal-content-container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-header {
  width: 100%;
  display: flex;
  justify-content: center;
}

.paragraph-one {
  margin-top: 1rem;
}

.paragraph-two {
  margin-bottom: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 2rem;
  width: 100%;
}
</style>
